import { KeyboardEvent, useRef } from 'react';

// Attach only to filter inputs so dropdowns and other controls keep their own keyboard behavior.
export default function useFilterKeyboard(apply: () => void) {
    const composing = useRef(false);

    const isComposing = (event: KeyboardEvent<HTMLInputElement>) =>
        composing.current || event.nativeEvent.isComposing || event.keyCode === 229;

    return {
        onCompositionStart: () => { composing.current = true; },
        onCompositionEnd: () => { composing.current = false; },
        onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => {
            if (event.key !== 'Enter') {
                return;
            }
            event.stopPropagation();
            // Enter may be confirming an IME candidate; let the input finish composing.
            if (isComposing(event)) {
                return;
            }
            // Block implicit form submission even if the filter is incomplete or Enter is held.
            event.preventDefault();
            if (!event.repeat) {
                apply();
            }
        },
        onKeyUp: (event: KeyboardEvent<HTMLInputElement>) => {
            if (event.key !== 'Enter') {
                return;
            }
            event.stopPropagation();
            if (!isComposing(event)) {
                event.preventDefault();
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/util/hooks/use-filter-keyboard.ts